module.exports = __webpack_public_path__ + "media/images/redesign-images/corporate/space-2-medium-81bc55dc82d3f1a48c81c376b407acd2.jpg";